module.exports.MINUTES_15 = 1 / 96;
module.exports.MINUTES_30 = 1 / 48;



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/src/helper/times.js
// module id = 466
// module chunks = 0